import styled from 'styled-components';

import colors from '@theme/colors';
import checkIcon from '@assets/icons/check-dark.svg';

export const FieldCheckbox = styled.div`
  display: flex;
  flex-direction: center;
  margin: 0px;
  padding: 20px;
  border-bottom: ${({ showBorder }) =>
    showBorder ? '1px solid #c4c4c4' : 'none'};
  border-left: ${({ showBorder }) =>
    showBorder ? '1px solid #c4c4c4' : 'none'};
  border-right: ${({ showBorder }) =>
    showBorder ? '1px solid #c4c4c4' : 'none'};
  border-top: ${({ showBorder }) =>
    showBorder ? '1px solid #c4c4c4' : 'none'};
`;

export const FieldCheckboxInput = styled.input`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid black;
  font-family: GT America;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  display: table;
  color: ${colors['charcoal']};
  border: ${({ dark }) =>
    dark ? `solid 1px ${colors['egg-shell']}` : `solid 1px ${colors['ash']}`};

  &:focus {
    outline: none;
  }
  &:checked {
    background-color: black;
    background-image: url(${checkIcon});
    background-size: 1.5rem 1.5rem;
    background-position: center;
  }

  &.ltr {
    margin-right: 1em;
  }
  &.rtl {
    margin-left: 1em;
  }
`;

export const FieldCheckboxLabel = styled.div`
  color: ${({ dark }) => (dark ? colors['beige'] : colors['charcoal'])};
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  display: flex;
  display: -moz-box;
  display: -webkit-flexbox;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: -moz-flex;
  flex-basis: fit-content;
  padding: 2px;
`;
